"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForceBudgetAllocationResponseSchema = exports.ListBudgetAllocationsQuerySchema = exports.ListBudgetAllocationsResponseSchema = exports.GetBudgetAllocationsResponseSchema = exports.DripBudgetBodySchema = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
exports.DripBudgetBodySchema = (0, core_1.StrictObject)({
    details: ruby_1.AllocationDetailsSchema,
    message: core_1.DescriptionSchema,
});
exports.GetBudgetAllocationsResponseSchema = common_1.BudgetAllocationResponseSchema;
exports.ListBudgetAllocationsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.BudgetAllocationResponseSchema);
exports.ListBudgetAllocationsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
});
exports.ForceBudgetAllocationResponseSchema = common_1.BudgetAllocationResponseSchema;
